/**
 * Admin display date format: DD-MM-YY (e.g. 2026-05-22 → 22-05-26)
 */
export function formatAdminDate(dateInput) {
    if (dateInput == null || dateInput === "") {
        return "-";
    }

    const value = String(dateInput).trim();
    if (!value || value === "-") {
        return "-";
    }
    if (value === "N/A" || value === "No End Date") {
        return value;
    }

    if (/^\d{2}-\d{2}-\d{2}$/.test(value)) {
        return value;
    }

    const isoDateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (isoDateOnly) {
        const [, year, month, day] = isoDateOnly;
        return `${day}-${month}-${year.slice(-2)}`;
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
}
